import { z } from "zod"

export const MarkChatsAsReadSchema = z
  .object({
    storeId: z.string().uuid(),
    jobIds: z.array(z.string().uuid()),
    storeCustomerIds: z.array(z.string().uuid()).default([]),
  })
  .refine((value) => value.jobIds.length + value.storeCustomerIds.length > 0, {
    message: "At least one chat must be given",
  })

export type MarkChatsAsRead = z.infer<typeof MarkChatsAsReadSchema>
